// extracted by mini-css-extract-plugin
module.exports = {"root":"Auth_root__1sRVu","sidebar":"Auth_sidebar__2QmHY","main":"Auth_main__8SkOV"};